import axiosInstance from '@api/axiosInstance';
import { Dialog, Modal, Paper } from '@mui/material';
import EmailEditor from 'donbar-mail/EmailEditor';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from '@tanstack/react-router';
import api from '@api/apiServices';
import axios from 'axios';
import SelectEmailDesigns from '@Components/Specific/SelectTemplate/design-selection';
import SelectTemplate from '@Components/Specific/SelectTemplate';

// TODO: Show uses

const emptyMergeTags = {
    first_name: undefined,
    last_name: undefined,
    prefix: undefined,
    suffix: undefined,
    description: undefined,
    country: undefined,
    state: undefined,
    city: undefined,
    neighborhood: undefined,
    street: undefined,
    house_number: undefined,
    apartment_number: undefined,
    zip_code: undefined,
    address_notes: undefined,
    phone_numbers: undefined,
    email_addresses: undefined,
    profile_picture: undefined,
};

const SystemEmailEditor = props => {
    const { i18n, t } = useTranslation();
    const lang = i18n.language;
    const navigate = useNavigate();
    const location = useLocation();

    const { data: savedBlocks, refetch: refetchBlocks } = useQuery({
        queryKey: ['savedBlocks'],
        queryFn: () => api.emails.blocks.get(),
        initialData: [],
    });

    const { mutate: saveBlock } = useMutation({
        mutationFn: block => api.emails.blocks.postForm(block),
        onSuccess: refetchBlocks,
    });

    const { mutate: updateBlock } = useMutation({
        mutationFn: ({ id, ...block }) =>
            api.emails.blocks.patchForm(id, block),
        onSuccess: refetchBlocks,
    });

    const { mutate: deleteBlock } = useMutation({
        mutationFn: id => api.emails.blocks.delete(id),
        onSuccess: refetchBlocks,
    });

    const mergeTagsLabels = {
        first_name: t('mergeTags.First Name'),
        last_name: t('mergeTags.Last Name'),
        prefix: t('mergeTags.Prefix'),
        suffix: t('mergeTags.Suffix'),
        description: t('mergeTags.Description'),
        country: t('mergeTags.Country'),
        state: t('mergeTags.State'),
        city: t('mergeTags.City'),
        neighborhood: t('mergeTags.Neighborhood'),
        street: t('mergeTags.Street'),
        house_number: t('mergeTags.House Number'),
        apartment_number: t('mergeTags.Apartment Number'),
        zip_code: t('mergeTags.Zip Code'),
        address_notes: t('mergeTags.Address Notes'),
        phone_numbers: t('mergeTags.Phone Number'),
        email_addresses: t('mergeTags.Email Address'),
        profile_picture: t('mergeTags.Profile Picture'),
    };

    const uploadFile = async (file, onUploadProgress) => {
        const { name, size, type } = file;

        const generatedUrls = await api.emails['get-upload-url'].post({
            name,
            size,
            type,
            source_location: location.pathname,
        });

        const { fields, public_url } = generatedUrls;

        const formData = new FormData();
        Object.entries(fields).forEach(([key, value]) => {
            formData.append(key, value);
        });

        formData.append('file', file);

        return axios
            .postForm(import.meta.env.VITE_STORAGE_URL, formData, {
                onUploadProgress,
            })
            .then(() => public_url);
    };

    return (
        <Dialog
            open
            fullScreen
            PaperProps={{
                sx: {
                    borderRadius: 0,
                    padding: 0,
                    backgroundColor: 'white',
                },
            }}
            // transitionDuration={0}
        >
            <EmailEditor
                lang={lang}
                SelectTemplate={SelectTemplate}
                // publicTemplates={globalTemplates}
                navigateBack={() => navigate({ to: '../' })}
                // savedTemplates={userTemplates}
                saveBlock={saveBlock}
                savedBlocks={savedBlocks}
                updateBlock={updateBlock}
                deleteBlock={deleteBlock}
                mergeTagsLabels={mergeTagsLabels}
                mergeTags={emptyMergeTags}
                uploadFile={uploadFile}
                // designs={designs}
                {...props}
            />
        </Dialog>
    );
};

export default SystemEmailEditor;
